import { toast } from 'sonner'
import { Button } from '@/components/ui/button'
import { useBringAgentBack } from '@/queries/agent'
import { extractErrorMessage } from '@/queries/ticketMutations'
import { formatDateTime } from '@/lib/dates'
import { stoodDownLabel } from './agentLabels'
import type { AgentStoodDown } from '@/types/agent'

/** Staff Ignored the agent's question: it leaves the ticket alone, even on customer replies, until brought back. */
export function StoodDownNote({ ticketId, stoodDown }: { ticketId: string; stoodDown: AgentStoodDown }) {
  const bringBack = useBringAgentBack(ticketId)
  return (
    <div
      data-testid="agent-stood-down"
      className="mx-6 mt-2 flex flex-wrap items-center gap-x-3 gap-y-2 rounded-etn-card bg-etn-neutral-subtle px-3.5 py-2 text-etn-control text-etn-neutral-text"
    >
      <span className="font-semibold">{stoodDownLabel(stoodDown.byName, stoodDown.channel)}</span>
      <span className="text-etn-micro">{formatDateTime(stoodDown.at)}</span>
      <Button
        size="xs"
        variant="outline"
        className="ml-auto"
        disabled={bringBack.isPending}
        onClick={() => bringBack.mutate(undefined, { onError: err => toast.error(extractErrorMessage(err, 'Could not bring the agent back')) })}
      >
        Bring the agent back
      </Button>
    </div>
  )
}
